"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EActionTypes = void 0;
let EActionTypes = exports.EActionTypes = /*#__PURE__*/function (EActionTypes) {
  EActionTypes["SET_IS_MY_HOME_WIDGET"] = "MyHome/SetIsMyHomeWidget";
  EActionTypes["SET_WITH_ROOM_NUMBER_WIDGET"] = "MyHome/SetWithRoomNumberWidget";
  return EActionTypes;
}({});